/**
 * Link to download a snapshot file. Opens in a new tab.
 **/

import React, { useRef, useState } from 'react';
import { Button, Spinner } from '@cloudscape-design/components';

export interface DownloadProps {
  getUrlFunction: Function;
  setError: Function;
  getUrlFunctionProps: any;
  buttonContent: any;
  urlPath: any;
  buttonDisabled: boolean;
}

export function DownloadButton(props: DownloadProps) {
  const ref = useRef<HTMLAnchorElement>(null);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Button
        target="_blank"
        disabled={props.buttonDisabled || loading}
        onClick={() => {
          setLoading(true);
          const fetch = async () =>
            await props
              .getUrlFunction(props.getUrlFunctionProps)
              .then((response: any) => {
                const url = response.presignedUrl;
                if (ref.current && url) {
                  ref.current.href = url;
                  ref.current.download = ''; // Force download
                }
              })
              .catch(() => {
                props.setError(true);
              })
              .finally(() => {
                ref.current?.click();
                setLoading(false);
              });
          fetch();
        }}
      >
        {loading ? <Spinner /> : props.buttonContent}
      </Button>
      <a className="hidden" ref={ref} />
    </>
  );
}
